import { render, staticRenderFns } from "./AudioSearchExam.vue?vue&type=template&id=5a5870f8"
import script from "./AudioSearchExam.vue?vue&type=script&lang=js"
export * from "./AudioSearchExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports